/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useCallback, memo } from 'react';
import '../centerModal/css/centerModal.scss';
import { Modal, Form, FloatingLabel } from 'react-bootstrap';

import { toast } from 'react-toastify';
import { updateEmailWithOutVerification } from '../../Store/actions/profile.action';
import { getLocalStorage } from '../../common/common';
import { useDispatch, useSelector } from 'react-redux';

import { getUserDetails, postMenu } from '../../Store/actions/commonActions';
export const EmailUpdateModal = ({ title = '', show, onVerificationDone, onModalHide }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : ''
  );

  const [emailModalShow, setEmailModalShow] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  useEffect(() => {
    setEmailModalShow(show);
  }, [show]);

  const fetchUserDetails = () => {
    // refetchUserDetails();
    dispatch(
      getUserDetails((res) => {
        if (res != 'error') {
          setEmail(res?.data?.email ?? '');
          // setLocalStorage('user', res?.data);
        }
      })
    );
  };

  // const otpMailVerification = () => {
  //   if (otp) {
  //     let formdata = new FormData();
  //     formdata.append('type', 'emailverify');
  //     formdata.append('email', email);
  //     formdata.append('otp', otp);
  //     dispatch(
  //       otpVerifyForChange(formdata, (res) => {
  //         if (res != 'error') {
  //           if (res.status_code == 200) {
  //             log('response', res);
  //             setEmail('');
  //             setOtp('');
  //             fetchUserDetails();
  //             setEmailModalShow(false);
  //           } else if (res.status_code == 203) {
  //             toast.error(res?.message);
  //           }
  //         }
  //       })
  //     );
  //   } else {
  //     toast.error('Please enter the OTP');
  //   }
  // };

  const emailVerification = () => {
    if (email) {
      let regexEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!email.match(regexEmail)) {
        toast.error('Please Enter a Valid Email');
      } else {
        setBtnDisable(true);

        let formdata = new FormData();
        formdata.append('email', email); //'mobile', 'name', 'email', 'device'
        //for device value will be ""
        dispatch(
          updateEmailWithOutVerification(formdata, (res) => {
            setBtnDisable(false);
            if (res != 'error') {
              if (res.status_code == 200) {
                toast.success('Email update Sucessfull');
                fetchUserDetails();
                setEmailModalShow(false);
                onVerificationDone();
                // setModalSlide(2);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
          })
        );
      }
    } else {
      toast.error('Please fill the mandatory field');
    }
  };

  const onEmailModalHide = () => {
    setEmailModalShow(false);
    // if (onModalHide) {
    onModalHide();
    // }
  };

  const onKeyDownEmail = (e) => {
    if (e.key === 'Enter') {
      emailVerification();
    }
  };

  return (
    <Modal
      className="centerModal"
      size="md"
      centered
      show={emailModalShow}
      onHide={onEmailModalHide}
    >
      <Modal.Header className="position-relative p-4 border-0 mb-1">
        <Modal.Title className="fs-4 text-black fw-semibold">
          {title ?? 'Please Enter Your Email'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Form>
          <div className="w-100 centerModalFrm">
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Your Email *">
              <Form.Control
                className="fs-4"
                type="text"
                placeholder="Enter Your Email"
                value={email}
                onKeyDown={onKeyDownEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FloatingLabel>

            <div className="d-flex flex-wrap centerModalBttns">
              <button
                className="col fs-4 btn btn-danger py-3 px-4"
                type="button"
                onClick={onEmailModalHide}
                aria-label="Cancel"
              >
                Cancel
              </button>
              <button
                className="col fs-4 btn btn-primary py-3 px-4"
                type="button"
                onClick={emailVerification}
                disabled={btnDisable}
                aria-label={btnDisable ? 'Please Wait' : 'Submit'}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
